<template>
    <div>
        <b-card no-body class="p-20">
            <h2>Down Payment</h2>
        </b-card>

        <b-card no-body class="p-20 mt-4">
            <div class="row text-left">
                <div class="  col-md-4 mt-auto mb-auto ">
                    <label class="label"
                        >Cari Workorder<span style="color: red;">*</span></label
                    >
                </div>
                <div class="col-md-1 mt-auto mb-auto">
                    :
                </div>
                <div class="  col-md-7">
                    <!-- <MultiSelect
						class="w-100"
						:disabled="!woList"
						v-model="workorder_id"
						:options="woList.map(type => type.form_code)"
						:custom-label="opt => woList.find(x => x.form_code == opt).form_code + ' - ' + woList.find(x => x.form_code == opt).no_polisi + ' - ' + woList.find(x => x.form_code == opt).car_name"
						:searchable="true"
						:close-on-select="true"
						:multiple="false"
						:allow-empty="false"
						placeholder="Pilih ID Work Order"
					></MultiSelect> -->

                    <MultiSelect
                        class="w-100"
                        v-model="workorder_id"
                        :options="woList.map(x => x.form_code)"
                        :custom-label="
                            opt => woList.find(x => x.form_code == opt).name
                        "
                        :close-on-select="true"
                        :multiple="false"
                        :allow-empty="false"
                        :internal-search="false"
                        placeholder="Cari Nomor Wo ( Ketik Minimal 3 Kata )"
                        @search-change="debouceFunction"
                    >
                    </MultiSelect>
                </div>
            </div>
            
        </b-card>

        <b-card no-body class="mt-3 text-left p-20" v-if="listPayment.length > 0">
            <!-- {{listPayment}} -->
            <!-- <h4>
                Work Order Ini Sudah Di DP Sejumlah Rp.
                {{ numberWithCommas(listPayment.amount) }} Pada Tanggal
                {{ moment(listPayment.created_at).format('MMM DD,Y') }}
            </h4> -->
            <h5 class="mt-2">DP Tercatat</h5>
            <table
                class="table text-center border"
            >
                <thead>
                    <th>No.</th>
                    <th>Tanggal DP</th>
                    <th>Jumlah DP</th>
                    <td><i class="fa fa-cog"></i></td>
                </thead>
                <tbody>
                    <tr v-for="(payment , index) in listPayment">
                        <td>{{ index + 1 }}.</td>
                        <td>{{ moment(payment.created_at).format('MMM DD,Y') }}</td>
                        <td>{{ numberWithCommas(payment.amount) }}</td>
                        <td>
                            <button
                                class="btn btn-success"
                                @click="
                                    printTandaTerima(
                                        payment.amount , false
                                    )
                                "
                            >
                                Print
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-card>

		<div class="row">
			<div class="offset-lg-9 col-lg-3 mt-3">
				<button
					:disabled="!workorder_id"
					class="btn btn-success w-100"
					@click="
						printTandaTerima(
							form.amount , true
						)
					"
				>
					Print Kwitansi Sementara
				</button>
			</div>
		</div>

		<b-card class="pl-1 pr-1 pt-2 pb-2 mt-3">
			<div class=" text-left">
				<label class="label underline-title mb-3"
					>Input Harga Down Payment</label
				>
                <div class="row pl-3 mb-2">
					<div class="col-lg-1 col-2 flex-middle" style="padding-right:0px;background-color: #CACACA;">
						<h4 class="mt-1">Rp.</h4>
					</div>
					<div class="col-lg-11 col-10" style="padding-left:0px">
						<input
							type="text"
							class="form-control w-100 input--style-4"
							v-model="form.amount"
							:disabled="!workorder_id"
						/>
						
					</div>
                    
                </div>
				<span class="pl-2">** Default DP (10 % dari Total Tagihan)</span>
            </div>
		</b-card>

        <b-card class="p-20 mt-4" no-body v-if="workorder_id && workOrderDetail">
			<label class="label underline-title mb-3"
				>Informasi Down Payment</label
			>
            <div class="  row text-left mt-3">
                <div class="  col-md-4 mt-auto mb-auto ">
                    <label class="label">Total Tagihan Work Order</label>
                </div>
                <div class="col-md-1 mt-auto mb-auto">
                    :
                </div>
                <div class="  col-md-7">
                    <input
                        type="text"
                        class="form-control input--style-4"
                        disabled
                        v-model="totalTagihan"
                        style="background-color:#aaa"
                    />
                </div>
            </div>

            <div class="  row text-left mt-3">
                <div class="  col-md-4 mt-auto mb-auto ">
                    <label class="label"
                        >Tipe Pembayaran<span style="color:red">*</span></label
                    >
                </div>
                <div class="col-md-1 mt-auto mb-auto">
                    :
                </div>
                <div class="  col-md-7">
                    <MultiSelect
                        class="w-100"
                        v-model="form.payment_type_id"
                        :options="formPayment.map(x => x.id)"
                        :custom-label="
                            opt => formPayment.find(x => x.id == opt).name
                        "
                        :close-on-select="true"
                        :searchable="true"
                        :multiple="false"
                        :allow-empty="false"
                        placeholder="Pilih Tipe Pembayaran"
                    ></MultiSelect>
                </div>
            </div>

            <!-- <div class="  col-md-4 col-6 middle" >
					<h6 class="middle">Tipe Pembayaran : </h6>
				</div>
				<div class="col-6   col-md-4">
					
					
				</div> -->

            <template v-if="form.payment_type_id && form.payment_type_id < 4">
                <div class="  row text-left mt-3">
                    <div class="  col-md-4 mt-auto mb-auto ">
                        <label class="label"
                            >Nama Bank<span style="color:red">*</span></label
                        >
                    </div>
                    <div class="col-md-1 mt-auto mb-auto">
                        :
                    </div>
                    <div class="  col-md-7">
                        <MultiSelect
                            :options="listOfBank.map(x => x.name)"
                            v-model="form.bank_name"
                        />
                    </div>
                </div>
                <div class="  row text-left mt-3">
                    <div class="  col-md-4 mt-auto mb-auto ">
                        <label class="label"
                            >Nomor Rekening
                            / 4 Digit Terkahir Kartu<span style="color:red"
                                >*</span
                            ></label
                        >
                    </div>
                    <div class="col-md-1 mt-auto mb-auto">
                        :
                    </div>
                    <div class="  col-md-7">
                        <input
                            type="text"
                            v-model="form.bank_account"
                            class="form-control input--style-4"
                        />
                    </div>
                </div>
                <div class="  row text-left mt-3">
                    <div class="  col-md-4 mt-auto mb-auto ">
                        <label class="label"
                            >Tanggal Pembayaran<span style="color:red"
                                >*</span
                            ></label
                        >
                    </div>
                    <div class="col-md-1 mt-auto mb-auto">
                        :
                    </div>
                    <div class="  col-md-7">
                        <flat-pickr
                            v-model="form.created_at"
                            :config="rangeConfig"
                            placeholder="Pilih Tanggal"
                        ></flat-pickr>
                    </div>
                </div>

                <div
                    class="  row text-left mt-3"
                    v-if="form.payment_type_id < 3"
                >
                    <div class="  col-md-4 mt-auto mb-auto ">
                        <label class="label"
                            >Approval Code<span style="color:red"
                                >*</span
                            ></label
                        >
                    </div>
                    <div class="col-md-1 mt-auto mb-auto">
                        :
                    </div>
                    <div class="  col-md-7">
                        <input
                            type="text"
                            v-model="form.payment_approval_code"
                            class="form-control input--style-4"
                        />
                    </div>
                </div>
            </template>

            <div class="  row text-left mt-3">
                <div class="  col-md-4 mt-auto mb-auto ">
                    <label class="label">Deskripsi</label>
                </div>
                <div class="col-md-1 mt-auto mb-auto">
                    :
                </div>
                <div class="  col-md-7">
                    <textarea
                        rows="5"
                        class="form-control w-100"
                        v-model="form.description"
                    />
                </div>
            </div>
        </b-card>
		<div class="row" v-if="workorder_id">
			<div class="offset-9 col-3 mt-3">
				<button
					type="button"
					class="btn btn-info mt-3 w-100"
					@click="submitForm()"
				
				>
					Selesai
				</button>
			</div>
		</div>
    </div>
</template>

<script>
import moment from 'moment';
import debounce from 'debounce';
import env from '@/env';
export default {
    data() {
        return {
            workorder_id: null,
            woList: [],
            listPayment: [],
            extraCostList: null,
            moment,
            woDetail: null,
            totalJasa: 0,
            totalPart: 0,
            totalCost: 0,
            insuranceDetails: null,
            insuranceCompany: null,
            pphPercentage: null,
            woCost: 0,
            workOrderDetail: null,
            inputHarga: 0,
            form: {
                amount: null,
                description: '',
                work_order_payment_type_id: 3,
                payment_type_id: 1,
                transaction_type_id: 1,
                bank_name: '',
                bank_account: '',
                payment_approval_code: '',
                created_at: null
            },
            listOfBank: [],
            formPayment: [],
            rangeConfig: {
                altInput: true,
                altInputClass: 'form-control input flatpickr-input w-100',
                animate: !this.isRTL()
            },
            debouceFunction: null,
            totalTagihan : 0
        };
    },
    mounted() {
        // this.loadWorkOrder()
        this.getListOfBank();
        this.getPaymentType();
    },
    watch: {
        workorder_id: function() {
            if (!this.workorder_id) return;

            this.loadPayments();
        }
    },
    computed: {
        calculateTotalWo() {
            if (
                this.workorder_id &&
                this.workOrderDetail &&
                this.workOrderDetail.details.ppnTotal
            ){
				let total = this.calculateTotal()
                // console.log(total + 'AAAA')
				this.form.amount = parseInt(total.split(',').join('')) * 0.1
				return total;
			}   
            else return 0;
        }
    },
    created() {
        this.debouceFunction = debounce(query => {
            this.woList = [
                {
                    name: 'Loading.....',
                    form_code: 'Loading.....'
                }
            ];
            this.loadWorkOrder(query);
        }, 1000);
    },
    methods: {
        terbilang(value) {
            function terbilang(a) {
                var c = ' Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas'.split(
                    ' '
                );
                if (12 > a) var b = c[a];
                else
                    20 > a
                        ? (b = c[a - 10] + ' Belas')
                        : 100 > a
                        ? ((b = parseInt(String(a / 10).substr(0, 1))),
                          (b = c[b] + ' Puluh ' + c[a % 10]))
                        : 200 > a
                        ? (b = 'Seratus ' + terbilang(a - 100))
                        : 1e3 > a
                        ? ((b = parseInt(String(a / 100).substr(0, 1))),
                          (b = c[b] + ' Ratus ' + terbilang(a % 100)))
                        : 2e3 > a
                        ? (b = 'Seribu ' + terbilang(a - 1e3))
                        : 1e4 > a
                        ? ((b = parseInt(String(a / 1e3).substr(0, 1))),
                          (b = c[b] + ' Ribu ' + terbilang(a % 1e3)))
                        : 1e5 > a
                        ? ((b = parseInt(String(a / 100).substr(0, 2))),
                          (a %= 1e3),
                          (b = terbilang(b) + ' Ribu ' + terbilang(a)))
                        : 1e6 > a
                        ? ((b = parseInt(String(a / 1e3).substr(0, 3))),
                          (a %= 1e3),
                          (b = terbilang(b) + ' Ribu ' + terbilang(a)))
                        : 1e8 > a
                        ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
                          (a %= 1e6),
                          (b = terbilang(b) + ' Juta ' + terbilang(a)))
                        : 1e9 > a
                        ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
                          (a %= 1e6),
                          (b = terbilang(b) + ' Juta ' + terbilang(a)))
                        : 1e10 > a
                        ? ((b = parseInt(String(a / 1e9).substr(0, 1))),
                          (a %= 1e9),
                          (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                        : 1e11 > a
                        ? ((b = parseInt(String(a / 1e9).substr(0, 2))),
                          (a %= 1e9),
                          (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                        : 1e12 > a
                        ? ((b = parseInt(String(a / 1e9).substr(0, 3))),
                          (a %= 1e9),
                          (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                        : 1e13 > a
                        ? ((b = parseInt(String(a / 1e10).substr(0, 1))),
                          (a %= 1e10),
                          (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                        : 1e14 > a
                        ? ((b = parseInt(String(a / 1e12).substr(0, 2))),
                          (a %= 1e12),
                          (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                        : 1e15 > a
                        ? ((b = parseInt(String(a / 1e12).substr(0, 3))),
                          (a %= 1e12),
                          (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                        : 1e16 > a &&
                          ((b = parseInt(String(a / 1e15).substr(0, 1))),
                          (a %= 1e15),
                          (b = terbilang(b) + ' Kuadriliun ' + terbilang(a)));
                a = b.split(' ');
                c = [];
                for (b = 0; b < a.length; b++) '' != a[b] && c.push(a[b]);
                return c.join(' ');
            }
            return terbilang(value);
        },
        printTandaTerima(amount , format = false) {

			if(!amount) {
				this.$swal.fire({
					title: 'Error',
					text: 'Jumlah Dp Tidak Boleh Kosong',
					icon: 'error'
				})
				return
			}
			
			if(format)
				amount = parseInt(amount)
			
            this.$http({
                url: '/api/v1/workorder/print/printDoc',
                method: 'post',
                data: {
                    type: 'printDP',
                    data: {
                        form_code: this.workorder_id,
                        amount_text:
                            '## ' +
                            this.terbilang(amount) +
                            ' ##',
                        customer_name: this.woDetail.customer
                            ? this.woDetail.customer.name
                            : '-',
                        registration: this.woDetail.car.registration,
                        car_name: this.woDetail.car.car.name,
                        amount: this.numberWithCommas(amount)
                    }
                }
            })
                .then(resp => {
                    let data = resp.data.data;
                    console.log(data);
                    var prntWin = window.open('');
                    prntWin.document.write(
                        '<html><head><title>' +
                            name +
                            '</title></head><body>' +
                            '<iframe width="100%" height="100%" name="plugin" src="' +
                            env.baseImage +
                            '/' +
                            data +
                            '"></iframe></body></html>'
                    );
                    this.reason = null;

                    // prntWin.print();
                    // this.getKwitansiCounter()
                    this.printing = false;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        submitForm() {
            let bodyData = JSON.parse(JSON.stringify(this.form));
            bodyData.amount = typeof bodyData.amount != 'number' ? parseFloat(bodyData.amount.split(',').join('')) : bodyData.amount;

            if (
                bodyData.work_order_payment_type_id == 3 &&
                bodyData.amount >
                    parseFloat(
                        this.calculateTotal()
                            .split(',')
                            .join('')
                    )
            ) {
                this.$store.dispatch('triggerAlert', [
                    false,
                    'Harga Dp tidak bisa melebihi jumlah penagihan Work Order'
                ]);
                return;
            }

            this.$http
                .post(
                    '/api/v1/workorder-estimation/' +
                        this.workorder_id +
                        '/payment',
                    bodyData
                )
                .then(resp => {
                    this.$store.dispatch('triggerAlert', [
                        true,
                        'Pembayaran Berhasil Disimpan'
                    ]);
                    this.loadPaymentList();
                    // window.reload();
                    this.workorder_id = null
                    this.listPayment = []
                })
                .catch(err => {
                    if(err.response) {
                        console.log(err.response);
                        let array = err.response.data.data.details.map(
                            x => x.message
                        );
                        this.$store.dispatch('triggerAlert', [false, array]);
                    }
                    else {
                        console.log(err)
                        this.$store.dispatch('triggerAlert', [false, err]);
                    }
                });
        },
        getPaymentType() {
            this.$http
                .get('/api/v1/masterData/payment-type?pagination=false')
                .then(resp => {
                    this.formPayment = resp.data.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getListOfBank() {
            // /api/v1/masterData/bank
            this.$http
                .get('/api/v1/masterData/bank')
                .then(resp => {
                    this.listOfBank = resp.data.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        async loadPayments() {
            let getOtherCost = await this.getWoOtherCost();

            this.loadPaymentList();

            this.getWoDetails();
        },

        loadPaymentList() {
            this.$http
                .get(
                    '/api/v1/workorder-estimation/' +
                        this.workorder_id +
                        '/receipt'
                )
                .then(resp => {
                    this.listPayment = resp.data.data.filter(
                        x => x.work_order_payment_type_id == 3
                    );

                    

                    // this.extraCostList = resp.data.data.filter(x => x.work_order_payment_type_id == 4)
                })
                .catch(err => {
                    if(err.response) {
                        console.log(err.response);
                        let array = err.response.data.data.details.map(
                            x => x.message
                        );
                        this.$store.dispatch('triggerAlert', [false, array]);
                    }
                    else {
                        console.log(err)
                        this.$store.dispatch('triggerAlert', [false, err]);
                    }
                   
                });
        },
        getWoDetails() {
            this.$http
                .get(`/api/v1/workorder/${this.workorder_id}/detail`)
                .then(async resp => {
                    var data = resp.data.data;
                    let carDetail = this.$store.getters.getModelDetailById(
                        data.customer_car.car_id
                    );

                    this.woDetail = {
                        customer: data.customer,
                        car: data.customer_car,
                        work_order_id: this.workorder_id,
                        nomor_mesin: data.customer_car.engine_number,
                        nomor_rangka: data.customer_car.chassis_number,
                        nomor_polisi: data.customer_car.registration,
                        asuransi: data.customer_car.insurance,
                        // kerusakan : this.evaluateDamage(data.condition.figure),
                        tanggal_masuk: moment(data.created_at).format(
                            'DD MMM YY HH:mm'
                        ),
                        pelanggan: data.customer ? data.customer.name : '-',
                        cso: data.CSO,
                        merek: carDetail.brand_name,
                        tipe: carDetail.name,
                        // image: data.condition.figureOverall.front.image,
                        address: data.customer ? data.customer.address : '-',
                        warna: data.customer_car.car_color.name,
                        tahun: data.customer_car.year,
                        car_id: data.customer_car.car.brand_id,
                        car_name: data.customer_car.car.name.split(' ')[0],
                        // spk_documents : spk,
                        price: data.customer_car.price
                    };
                })
                .then(() => {
                    this.getPaymentWorkOrder();
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getPPhPercentage(id) {
            this.$http
                .get('/api/v1/insurance/company/' + id)
                .then(resp => {
                    let data = resp.data.data;
                    this.insuranceCompany = data;
                    // console.log(this.insuranceCompany)
                    this.pphPercentage = data.pph_insurance;
                    this.calculateTotal();
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getPaymentWorkOrder() {
            this.totalJasa = 0;
            this.totalPart = 0;
            this.totalCost = 0;
            this.woCost = 0;

            this.$http
                .get('/api/v1/workorder-estimation/' + this.workorder_id)
                .then(resp => {
                    this.workOrderDetail = resp.data.data;

                    let estimations = this.workOrderDetail.estimations;
                    let ppnPercentage = this.workOrderDetail.ppn;

                    let ppnTotal = 0;

                    this.insuranceDetails = this.woDetail.asuransi.find(
                        x => x.id == this.workOrderDetail.details.insurance_id
                    );
                    this.workOrderDetail.details.insurance_company_id = this.insuranceDetails.insurance_company;
                    this.getPPhPercentage(
                        this.workOrderDetail.details.insurance_company_id
                    );

                    this.totalJasa = this.workOrderDetail.details.totalJasa;
                    this.totalPart = this.workOrderDetail.details.totalPart;

                    let discountMultJasa =
                        parseFloat(this.workOrderDetail.details.discount) /
                        this.totalJasa;
                    let discountMultPart =
                        parseFloat(this.workOrderDetail.details.discount_part) /
                        this.totalPart;

                    let discountPPN =
                        parseFloat(this.workOrderDetail.details.discount) +
                        parseFloat(this.workOrderDetail.details.discount_part);

                    for (var i = 0; i < estimations.length; i++) {
                        if (!estimations[i].price_per_item) continue;

                        if (!estimations[i].is_approved_by_insurance) continue;

                        estimations[i].price_per_item = estimations[i]
                            .price_per_item
                            ? estimations[i].price_per_item
                            : 0;
                        estimations[i].markup = estimations[i].markup
                            ? estimations[i].markup
                            : 0;

                        estimations[i].price_per_item =
                            parseFloat(estimations[i].price_per_item) +
                            parseFloat(estimations[i].markup);

                        this.woCost +=
                            parseFloat(estimations[i].amount) *
                            parseFloat(estimations[i].price_per_item);
                        // console.log(estimations[i])

                        // if(estimations[i].is_approved_by_insurance == 1 && !estimations[i].is_supplied_by_insurance) {
                        let ppn = estimations[i].ppn_included;
                        let without_ppn = estimations[i].without_ppn;

                        let discountMult =
                            estimations[i].sparepart_type == 'J'
                                ? discountMultJasa
                                : discountMultPart;

                        estimations[i].price_per_item = parseFloat(
                            estimations[i].price_per_item
                        );

                        if (ppn && !without_ppn) {
                            estimations[i].price_per_item =
                                estimations[i].price_per_item /
                                (1 + ppnPercentage);
                            ppnTotal +=
                                parseFloat(estimations[i].price_per_item) *
                                parseFloat(estimations[i].amount) *
                                ppnPercentage;
                        } else if (!ppn && !without_ppn) {
                            ppnTotal +=
                                parseFloat(estimations[i].price_per_item) *
                                parseFloat(estimations[i].amount) *
                                ppnPercentage;
                        }

                        if (without_ppn) {
                            discountPPN =
                                discountPPN -
                                parseFloat(estimations[i].price_per_item) *
                                    parseFloat(estimations[i].amount) *
                                    discountMult;
                        }
                    }

                    if (ppnTotal != 0)
                        ppnTotal = Math.max(
                            0,
                            ppnTotal - discountPPN * ppnPercentage
                        );
                    this.workOrderDetail.details.ppnTotal = ppnTotal;
                })
                .then(() => {
                    let total = this.calculateTotal()
                    // console.log(total + 'AAAA')
                    console.log(total)
				    this.form.amount = (parseInt(total.split(',').join('')) * 0.1).toFixed(0)
                    this.totalTagihan = total;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        calculateTotal() {
            let priceAfterDiscountJasa =
                this.totalJasa -
                parseFloat(this.workOrderDetail.details.discount);
            let priceAfterDiscountPart =
                this.totalPart -
                parseFloat(this.workOrderDetail.details.discount_part);
            let ppn = parseFloat(this.workOrderDetail.details.ppnTotal);
            this.workOrderDetail.details.pph =
                ((100 - this.pphPercentage) / 100) *
                0.02 *
                priceAfterDiscountJasa;
            this.workOrderDetail.details.totalAfterDisc =
                priceAfterDiscountJasa +
                priceAfterDiscountPart +
                parseFloat(this.workOrderDetail.details.derek) -
                parseFloat(this.workOrderDetail.details.own_risk) +
                ppn;

            this.workOrderDetail.details = Object.assign(
                {},
                this.workOrderDetail.details
            );

            let total =
                this.workOrderDetail.details.totalAfterDisc -
                this.workOrderDetail.details.pph;

            // console.log(total)
            let dp = this.listPayment;
            

            // console.log(dp)
            if (dp.length > 0) {
                let dpTotal = 0
                for(var i = 0 ; i < dp.length; i ++)
                    dpTotal += parseFloat(dp[i].amount)

                total = total - dpTotal;
                this.dp = dpTotal;
                // console.log(total);
            }

            total > 0 ? (this.negative = false) : (this.negative = true);
            // alert(total)
            return this.numberWithCommas(total.toFixed(0));
        },
        async getWoOtherCost() {
            try {
                let resp = await this.$http.get(
                    '/api/v1/workorder-estimation/' +
                        this.workorder_id +
                        '/other-cost'
                );
                let data = resp.data.data;

                let modelExtraCost = {
                    price: 0,
                    id: null,
                    description: null
                };

                let extraCost = [];

                for (var i = 0; i < data.length; i++) {
                    console.log(data[i]);
                    let model = JSON.parse(JSON.stringify(modelExtraCost));
                    model.description = data[i].description;
                    model.amount = data[i].price;
                    model.id = data[i].id;
                    extraCost.push(model);
                }

                return extraCost;
            } catch (err) {
                this.$store.dispatch('triggerAlert', [
                    false,
                    err,
                    'Failed to get Biaya Lain Lainnya.'
                ]);
                console.log(err);
            }
        },
        async loadWorkOrder(search = null) {
            // this.woList = [];

            let queryParam = '';

            if (search) {
                queryParam += `&search=${search}`;
            }

            console.log(queryParam);

            this.$http
                .get(
                    '/api/v1/masterData/workorder?pagination=false&order=DESC&by=created_at' +
                        queryParam
                )
                .then(resp => {
                    // this.woList = resp.data.data
                    this.$set(this, 'woList', resp.data.data);

                    for (var i = 0; i < this.woList.length; i++) {
                        this.woList[i].name =
                            this.woList[i].form_code +
                            ' - ' +
                            this.woList[i].no_polisi +
                            ' - ' +
                            this.woList[i].car_name;
                    }
                    // console.log(this.woList)
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style scoped>
	.amount[type='text'] { font-size: 12px; }

	.flex-middle {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.underline-title {
		text-decoration-line: underline;
		text-underline-offset: 6px;
	}

	.label {
		font-size: 15px;
	}
</style>
